import React from 'react';
import PartnerAddContainer from '../../containers/partnermng/PartnerAddContainer';

const PartnerAddPage = ({ handleClose, isModal }) => {
  return (
    <PartnerAddContainer handleClose={handleClose} isModal={isModal} />
  );
};

export default PartnerAddPage;
